import React from 'react';
import PolicyModal from '../PolicyModal/PolicyModal';
import TermsModal from '../TermsModal/TermsModal';
import contactPoint from '../../constants/contactPoint';
import {
  HiOutlineOfficeBuilding,
  HiOutlineHashtag,
  HiOutlineLocationMarker,
  HiOutlinePhone,
  HiOutlineMail,
} from 'react-icons/hi';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white mt-12">
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
          {/* Logo and description */}
          <div>
            <span className="block text-2xl font-extrabold tracking-tight text-white mb-4 drop-shadow-xl">
              Licitatii-Constructii.ro
            </span>
            <p className="text-gray-400 text-sm">
              {import.meta.env.VITE_NAME} este primul portal de achiziții
              publice dedicat proiectelor de construcții, oferind transparență
              și acces facil la procedurile de achiziții, de la planificare până
              la publicarea în SEAP și integrarea datelor în platformă.
            </p>
          </div>

          {/* Links */}
          <div className="md:ml-8">
            <h3 className="text-lg font-semibold mb-4">Link-uri</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="/licitatii"
                  className="text-gray-300 hover:text-white transition"
                >
                  Licitatii
                </a>
              </li>
              <li>
                <a
                  href="/achizitii-directe"
                  className="text-gray-300 hover:text-white transition"
                >
                  Proiecte
                </a>
              </li>
              <li>
                <a
                  href="/anunturi-atribuire"
                  className="text-gray-300 hover:text-white transition"
                >
                  Anunțuri de Atribuire
                </a>
              </li>
              <li>
                <a
                  href="/abonamente"
                  className="text-gray-300 hover:text-white transition"
                >
                  Abonamente
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <PolicyModal />
              </li>
              <li>
                <TermsModal />
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <p className="flex items-center mb-2 text-sm text-gray-300 gap-2">
              <HiOutlineOfficeBuilding className="text-green-400 text-lg" />{' '}
              {contactPoint.companyName}
            </p>
            <p className="flex items-center mb-2 text-sm text-gray-300 gap-2">
              <HiOutlineHashtag className="text-indigo-400 text-lg" /> Cod Unic
              de Înregistrare: {contactPoint.taxIdentificationNumber}
            </p>
            <p className="flex items-center mb-2 text-sm text-gray-300 gap-2">
              Nr. Înmatriculare: {contactPoint.registrationNumber}
            </p>
            <br />
            <p className="flex items-center mb-2 text-sm text-gray-300 gap-2">
              <HiOutlineLocationMarker className="text-yellow-400 text-lg" />{' '}
              {contactPoint.address}
            </p>
            <p className="flex items-center mb-2 text-sm text-gray-300 gap-2">
              <HiOutlinePhone className="text-green-400 text-lg" />
              <a
                href={`tel:${contactPoint.phone}`}
                className="hover:text-white transition"
              >
                {contactPoint.phone}
              </a>
            </p>
            <p className="flex items-center text-sm text-gray-300 gap-2">
              <HiOutlineMail className="text-indigo-400 text-lg" />{' '}
              {contactPoint.displayEmail}
            </p>
          </div>
        </div>
      </div>
      {/* Footer Bottom */}
      <div className="bg-gray-800 py-4 text-center text-gray-400 mt-8">
        <p>
          &copy; {new Date().getFullYear()} {import.meta.env.VITE_NAME}. Toate
          drepturile rezervate.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
